import React from "react";

import {
  FaBan,
  FaEdit,
  FaEye,
  FaSpinner,
  FaUserCircle,
} from "react-icons/fa";

import {
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";

import "./UserTable.css";

const UserTable = ({
  users = [],
  loading = false,
  page = 1,
  limit = 10,
  totalRecords = 0,
  totalPages = 1,
  setPage,
  onLimitChange,
  handleView,
  handleEdit,
  handleStatus,
}) => {
  const getStatusClass = (
    status
  ) => {
    switch (
      String(
        status || ""
      ).toUpperCase()
    ) {
      case "ACTIVE":
        return "status-active";

      case "BLOCKED":
        return "status-blocked";

      case "INACTIVE":
        return "status-inactive";

      default:
        return "";
    }
  };

  const getStatusLabel = (
    status
  ) => {
    const normalizedStatus =
      String(
        status || ""
      ).toUpperCase();

    const labels = {
      ACTIVE: "Active",
      INACTIVE: "Inactive",
      BLOCKED: "Blocked",
    };

    return (
      labels[
        normalizedStatus
      ] || "-"
    );
  };

  const formatDate = (
    value
  ) => {
    if (!value) {
      return "-";
    }

    const date =
      new Date(value);

    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return "-";
    }

    return new Intl.DateTimeFormat(
      "en-IN",
      {
        dateStyle: "medium",
        timeStyle: "short",
      }
    ).format(date);
  };

  const getSerialNumber = (
    index
  ) => {
    return (
      (Number(page) - 1) *
        Number(limit) +
      index +
      1
    );
  };

  if (loading) {
    return (
      <div className="user-table-loader">
        <FaSpinner className="loader-spin" />

        <p>
          Loading Customers...
        </p>
      </div>
    );
  }

  return (
    <div className="user-table-wrapper">
      <div className="user-table-scroll">
        <table className="user-table">
          <thead>
            <tr>
              <th>
                S.No
              </th>

              <th>
                Customer
              </th>

              <th>
                Mobile
              </th>

              <th>
                Email
              </th>

              <th>
                Role
              </th>

              <th>
                Verification
              </th>

              <th>
                Status
              </th>

              <th>
                Last Login
              </th>

              <th>
                Registered On
              </th>

              <th>
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            {users.length ===
            0 ? (
              <tr>
                <td
                  colSpan={10}
                  className="no-data"
                >
                  No Customers Found
                </td>
              </tr>
            ) : (
              users.map(
                (
                  user,
                  index
                ) => (
                  <tr
                    key={
                      user?._id ||
                      index
                    }
                  >
                    <td className="user-table-serial">
                      {getSerialNumber(
                        index
                      )}
                    </td>

                    <td>
                      <div className="table-user">
                        {user?.profileImage ? (
                          <img
                            src={
                              user.profileImage
                            }
                            alt={
                              user?.name ||
                              "Customer"
                            }
                            className="table-avatar"
                            onError={(
                              event
                            ) => {
                              event.currentTarget.style.display =
                                "none";
                            }}
                          />
                        ) : (
                          <FaUserCircle className="table-avatar-icon" />
                        )}

                        <div className="table-user-info">
                          <strong>
                            {user?.name ||
                              user?.fullName ||
                              "Unknown Customer"}
                          </strong>

                          <span>
                            ID:{" "}
                            {user?._id ||
                              "-"}
                          </span>
                        </div>
                      </div>
                    </td>

                    <td>
                      {user?.mobile ||
                        user?.phone ||
                        "-"}
                    </td>

                    <td>
                      {user?.email ||
                        "-"}
                    </td>

                    <td>
                      <span className="user-role-badge">
                        {String(
                          user?.role ||
                            "USER"
                        ).toUpperCase()}
                      </span>
                    </td>

                    <td>
                      <div className="user-verification-cell">
                        <span
                          className={
                            user?.isVerified
                              ? "verified"
                              : "not-verified"
                          }
                        >
                          {user?.isVerified
                            ? "Verified"
                            : "Not Verified"}
                        </span>

                        <small>
                          Mobile:{" "}
                          {user?.mobileVerified
                            ? "Verified"
                            : "Pending"}
                        </small>
                      </div>
                    </td>

                    <td>
                      <span
                        className={`status-badge ${getStatusClass(
                          user?.status
                        )}`}
                      >
                        {getStatusLabel(
                          user?.status
                        )}
                      </span>
                    </td>

                    <td>
                      <span className="user-date-cell">
                        {formatDate(
                          user?.lastLogin
                        )}
                      </span>
                    </td>

                    <td>
                      <span className="user-date-cell">
                        {formatDate(
                          user?.createdAt
                        )}
                      </span>
                    </td>

                    <td>
                      <div className="table-actions">
                        <button
                          type="button"
                          className="action-btn view-btn"
                          title="View customer"
                          onClick={() =>
                            handleView(
                              user
                            )
                          }
                        >
                          <FaEye />
                        </button>

                        <button
                          type="button"
                          className="action-btn edit-btn"
                          title="Edit customer"
                          onClick={() =>
                            handleEdit(
                              user
                            )
                          }
                        >
                          <FaEdit />
                        </button>

                        <button
                          type="button"
                          className="action-btn block-btn"
                          title="Change status"
                          onClick={() =>
                            handleStatus(
                              user
                            )
                          }
                        >
                          <FaBan />
                        </button>
                      </div>
                    </td>
                  </tr>
                )
              )
            )}
          </tbody>
        </table>
      </div>

     {totalRecords > 0 ? (
  <div className="customer-pagination-wrapper">
    <div className="customer-pagination-info">
      Showing{" "}
      <strong>
        {(page - 1) * limit + 1}
      </strong>{" "}
      to{" "}
      <strong>
        {Math.min(
          page * limit,
          totalRecords
        )}
      </strong>{" "}
      of{" "}
      <strong>
        {totalRecords}
      </strong>{" "}
      customers
    </div>

    <div className="customer-pagination-main">
      <button
        type="button"
        className="customer-pagination-nav"
        disabled={Number(page) <= 1}
        onClick={() =>
          setPage(
            Number(page) - 1
          )
        }
        aria-label="Previous page"
      >
        <FiChevronLeft />
      </button>

      <div className="customer-pagination-page">
        <span>Page</span>

        <strong>
          {page}
        </strong>

        <span>of</span>

        <strong>
          {Math.max(
            Number(totalPages) ||
              1,
            1
          )}
        </strong>
      </div>

      <button
        type="button"
        className="customer-pagination-nav"
        disabled={
          Number(page) >=
          Math.max(
            Number(totalPages) ||
              1,
            1
          )
        }
        onClick={() =>
          setPage(
            Number(page) + 1
          )
        }
        aria-label="Next page"
      >
        <FiChevronRight />
      </button>
    </div>

    <div className="customer-pagination-limit">
      <span>
        Rows per page
      </span>

      <select
        value={limit}
        onChange={(event) =>
          onLimitChange(
            Number(
              event.target.value
            )
          )
        }
      >
        <option value={10}>
          10
        </option>

        <option value={20}>
          20
        </option>

        <option value={50}>
          50
        </option>

        <option value={100}>
          100
        </option>
      </select>
    </div>
  </div>
      ) : null}
    </div>
  );
};

export default UserTable;